import { Alert, AppBar, Chip, Stack, SxProps, Theme } from '@mui/material';
import { green, grey } from '@mui/material/colors';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { navigateTabsWithQueries } from '../types/cutterState';
import { ConnVsContractCtrl } from './connVsContractCtrl';
import BizDistribAnalysis from './BizDistribAnalysis';
import EquipmentOrdersDashboard from './EquipmentOrdersDashboard';
import EquipmentUpgradePriority from './EquipmentUpgradePriority';
import HelpIcon from '../help/HelpIcon';

const ConnexionStats: React.FC = () => {
    const [stats, setStats] = React.useState('ConnVsContract');
    const navigate = useNavigate();
    const location = useLocation();

    const getChipStyles = (isSelected: boolean): SxProps<Theme> => ({
        bgcolor: (theme: any) => isSelected 
            ? (theme.palette.mode === 'light' ? green[700] : green[800])
            : (theme.palette.mode === 'light' ? 'white' : theme.palette.background.paper),
        color: (theme: any) => isSelected ? 'white' : 'inherit',
        borderColor: (theme: any) => isSelected 
            ? (theme.palette.mode === 'light' ? green[700] : green[800])
            : undefined
    });

    let component: React.JSX.Element = (<div></div>);


    React.useEffect(() => {
        // execute on location change
        const queryParams: URLSearchParams = new URLSearchParams(location.search);
        if (queryParams.has('stats')) {
            setStats(location.pathname === "?" ? '' : queryParams.get('stats')!);
        }
    }, [location]);


    switch (stats) {
        case 'ConnVsContract':
            component = (<ConnVsContractCtrl />);
            break;
        case 'CuttersDistribution':
            component = (<BizDistribAnalysis />);
            break;
        case 'EquipmentOrders':
            component = (<EquipmentOrdersDashboard />);
            break;
        case 'CuttersToUpgrade':
            component = (<EquipmentUpgradePriority />);
            break;
        default:
            component = (<Alert severity="info" sx={{ justifySelf: 'center', flexDirection: 'row' }}>
                <strong>Coming soon !</strong>
            </Alert>);
    }

    return (
        <Stack direction="column">
            <AppBar position="static"
                color="default"
                elevation={0}
                sx={{ 
                    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                    backgroundColor: (theme) => theme.palette.mode === 'light' ? grey[100] : '#252525',
                    marginY: 0, 
                    minHeight: 0 
                }}>
                <Stack direction="row" component="ul" sx={{
                    padding: 0, display: "flex-start", justifyContent: "flex-start", flexWrap: "nowrap", listStyle: "none",
                    marginY: 1, overflow: "auto",
                    "& .MuiChip-root": {
                        marginX: '0.2rem'
                    }
                }} >

                    <Chip variant="outlined" clickable component="a" label={
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                            Connection vs Contract
                            <HelpIcon helpContext="stats-conn-vs-contract" placement="bottom" size="small" />
                        </Stack>
                    }
                        sx={getChipStyles(stats === 'ConnVsContract')}
                        href="#" onClick={() => navigateTabsWithQueries(navigate, 'stats', 'ConnVsContract')} />

                    <Chip variant="outlined" clickable component="a" label={
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                            Cutters that need upgrade
                            <HelpIcon helpContext="stats-upgrade-priority" placement="bottom" size="small" />
                        </Stack>
                    }
                        sx={getChipStyles(stats === 'CuttersToUpgrade')}
                        href="#" onClick={() => navigateTabsWithQueries(navigate, 'stats', 'CuttersToUpgrade')} />

                    <Chip disabled variant="outlined" clickable component="a" label={'Connection rates'}
                        sx={getChipStyles(stats === 'ConnRates')}
                        href="#" onClick={() => navigateTabsWithQueries(navigate, 'stats', 'ConnRates')} />

                    <Chip variant="outlined" clickable component="a" label={
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                            Distribution breakdowns
                            <HelpIcon helpContext="stats-distribution" placement="bottom" size="small" />
                        </Stack>
                    }
                        sx={getChipStyles(stats === 'CuttersDistribution')}
                        href="#" onClick={() => navigateTabsWithQueries(navigate, 'stats', 'CuttersDistribution')} />

                    <Chip variant="outlined" clickable component="a" label={
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                            Sales history
                            <HelpIcon helpContext="stats-sales-history" placement="bottom" size="small" />
                        </Stack>
                    }
                        sx={getChipStyles(stats === 'EquipmentOrders')}
                        href="#" onClick={() => navigateTabsWithQueries(navigate, 'stats', 'EquipmentOrders')} />

                    {/*
                 
                        <Chip disabled variant="outlined" clickable component="a" label={'Shared server or standalone ?'}
                            sx={{ bgcolor: (stats === 'SharedServices' ? green[200] : 'white') }}
                            href="#" onClick={() => navigateTabsWithQueries(navigate, 'stats', 'SharedServices')} /
                    */}
                </Stack>
            </AppBar>
            {component}

        </Stack>
    );
}

export default ConnexionStats;



